import React, {useRef} from 'react'
import './navbar.css';
import camera from './../assets/camera.png'
import { Link, withRouter} from 'react-router-dom'
import firebase from './../../config/fbConfig.js'
import menuButton from './../assets/menuButton.png'

const auth = firebase.auth();


function Navbar(props) {
	const timeoutRef = useRef(null)
	let signOut = () => {
		auth.signOut().then(() => {
			alert('Successfully signed out');
			props.history.push('/');
		});
	};
	
	let showMenu = () => {
		document.getElementById('nav').children[2].style.visibility = 'visible';
		document.getElementById('nav').children[2].classList.add('animate');
		document.getElementById('nav').children[2].style.top = document.getElementById('nav').children[2].getBoundingClientRect().top * -1 + 'px';
		document.getElementById('menu').style.visibility = 'hidden';

		// In case the user didn't click anything for 3 seconds, so hiding again
		timeoutRef.current = setTimeout(() => {
			document.getElementById('nav').children[2].style.visibility = 'hidden';
			document.getElementById('nav').children[2].classList.remove('animate');
			document.getElementById('nav').children[2].style.top = '0px';
			document.getElementById('menu').style.visibility = 'visible';
			}, 3000);
	}

	
	let clickOnLi = (e) => {
		clearTimeout(timeoutRef.current);
		if (e.target.tagName==="LI" && window.innerWidth<1160) {
			document.getElementById('nav').children[2].style.visibility = 'hidden';
			document.getElementById('nav').children[2].classList.remove('animate');
			document.getElementById('nav').children[2].style.top = '0px';
			document.getElementById('menu').style.visibility = 'visible';
		}	
	}

	return (
		<div id="nav">
		<span>PhotoGems</span>
			<img id="logo" src={camera} alt="A camera"/>
			<ul onClick={clickOnLi}>	
					{props.user ? <a><li onClick={signOut}>Logout</li></a> : <Link to="/login"><li>Sign in</li></Link>}
					{props.user &&  <Link to="/profile"><li>My Profile</li></Link>}
					<Link to="/feed"><li>Feed</li></Link>
					<Link to="/"><li>Home</li></Link>
			</ul>
			<img id="menu" src={menuButton} alt="menu" onClick={showMenu}/>
		</div>
	)
}

export default withRouter(Navbar)